import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog } from '@yola/ws-ui';

const defaultCaptions = {
  title: 'Something went wrong',
  description: 'Please reload the page',
  dismiss: 'Reload',
};

const defaultOnDismiss = () => window.location.reload();

const CriticalErrorDialog = ({
  captions = defaultCaptions,
  glyph = 'alert-circle',
  handleCancel = null,
  onSubmit = null,
  onDismiss = defaultOnDismiss,
  ...otherProps
}) => (
  <AlertDialog
    captions={captions}
    glyph={glyph}
    handleCancel={handleCancel}
    onSubmit={onSubmit}
    onDismiss={onDismiss}
    {...otherProps}
  />
);

CriticalErrorDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    dismiss: PropTypes.string,
  }),
  glyph: PropTypes.string,
  handleCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func,
};

export default CriticalErrorDialog;
